<template>
  <v-list dark>
    <div
      class="title px-3"
      :class="group.satisfied ? 'success--text' : 'error--text'"
    >
      {{ group.mandatory ? 'Mandatory' : 'Conditional' }} Qualification {{ group.negative ? 'Elimination' : 'Requirement'}}
    </div>

    <div v-if="group.satisfied && group.profileQualification">
      <v-subheader>{{ group.profileQualification.description }}</v-subheader>

      <v-list-tile
        v-for="requirement in group.profileQualification.requirements"
        :class="{ satisfied: requirement.satisfied, failed: !requirement.satisfied, requirement: true }"
        :key="requirement.id"
      >
        <v-list-tile-avatar><v-icon>{{ requirement.satisfied ? 'mdi-check' : 'mdi-alert-outline' }}</v-icon></v-list-tile-avatar>
        <v-list-tile-content>
          <v-tooltip bottom max-width="50%">
            <v-list-tile-title slot="activator" v-html="requirement.reason" :class="reasonClass(requirement)" />
            <span v-html="requirement.reason" />
          </v-tooltip>
        </v-list-tile-content>
      </v-list-tile>
    </div>

    <div v-else-if="group.satisfied && group.negative">
      <v-list-tile v-for="requirement in group.requirements" :key="`group-${group.id}-requirement-${requirement.id}`">
        <v-list-tile-avatar><v-icon>mdi-check</v-icon></v-list-tile-avatar>
        <v-list-tile-content>
          <v-tooltip bottom max-width="50%">
            <v-list-tile-title slot="activator" v-html="requirement.reason" :class="reasonClass(requirement)" />
            <span v-html="requirement.reason" />
          </v-tooltip>
        </v-list-tile-content>
      </v-list-tile>
    </div>

    <div v-else>
      <div v-for="qualification in group.profileQualifications" :key="qualification.id">
        <v-subheader>{{ qualification.description }}</v-subheader>

        <v-list-tile
          v-for="requirement in qualification.requirements"
          :class="{satisfied: requirement.satisfied, failed: !requirement.satisfied, requirement: true}"
          :key="requirement.id"
        >
          <v-list-tile-avatar><v-icon>{{ requirement.satisfied ? 'mdi-check' : 'mdi-alert-outline' }}</v-icon></v-list-tile-avatar>
          <v-list-tile-content>
            <v-tooltip bottom max-width="50%">
              <v-list-tile-title slot="activator" v-html="requirement.reason" :class="reasonClass(requirement)" />
              <span v-html="requirement.reason" />
            </v-tooltip>
          </v-list-tile-content>
        </v-list-tile>
      </div>
    </div>
  </v-list>
</template>

<script>
// Vue Component
export default {
  props: { group: Object },
  methods: {
    reasonClass(requirement) {
      if (requirement.satisfied) return 'success-text'
      if (!requirement.satisfied && requirement.mandatory) return 'error-text'
      if (!requirement.mandatory && !requirement.satisfied)
        return 'warning-text'
    },
  },
}
</script>
